module.exports = __webpack_public_path__ + "static/media/Main_Logo.3992006d.png";